import { defineMessages } from "react-intl";
const messages = defineMessages({
    spaceCoverPhotoUploadTitle: {
        id: "app.space.details.coverPhotoTitle.text",
        defaultMessage: "Cover Photo",
    },
    updateSpaceCoverPhotoSuccess: {
        id: "app.space.details.coverPhoto.update.success.text",
        defaultMessage: "Cover photo updated successfully.",
    },
});
export default messages;
